<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title122"></a>
<div class="p-c-br"><span><em class="i">For Roland C. Greefkes, extraordinary creator</em> <br/><em class="i">of magical flower gates, with many heartfelt thanks</em> <br/><em class="i">from Hannah and myself for our own</em> <br/><em class="i">enchanted protection.</em></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429911641_ded01.vue?7bf11db2